import { useLocalSearchParams } from 'expo-router';

import IncomeSplit from '../../../banking/components/income-split/IncomeSplit';
import IncomeSplitNew from '../../../banking/components/income-split/IncomeSplitNew';
import useShouldSeeTiedRules from '../../../banking/hooks/income-split/useShouldSeeRuleSets';

export default function IncomeSplitScreen() {
    const { welcome } = useLocalSearchParams();
    const welcomePage = welcome === 'true';

    const enableTiedRules = useShouldSeeTiedRules();

    if (enableTiedRules) {
        return <IncomeSplitNew welcome={welcomePage} />;
    }

    return <IncomeSplit welcome={welcomePage} />;
}
